var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 2,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2103 6.6463C13.6107 6.13101 14.3893 6.13101 14.7897 6.6463L15.2135 7.19174C15.8631 8.02793 16.9055 8.45968 17.9561 8.3278L18.6415 8.24177C19.2889 8.16049 19.8395 8.71107 19.7582 9.35853L19.6722 10.0439C19.5403 11.0945 19.9721 12.1369 20.8083 12.7865L21.3537 13.2103C21.869 13.6107 21.869 14.3893 21.3537 14.7897L20.8083 15.2135C19.9721 15.8631 19.5403 16.9055 19.6722 17.9561L19.7582 18.6415C19.8395 19.2889 19.2889 19.8395 18.6415 19.7582L17.9561 19.6722C16.9055 19.5403 15.8631 19.9721 15.2135 20.8083L14.7897 21.3537C14.3893 21.869 13.6107 21.869 13.2103 21.3537L12.7865 20.8083C12.1369 19.9721 11.0945 19.5403 10.0439 19.6722L9.35853 19.7582C8.71107 19.8395 8.16049 19.2889 8.24177 18.6415L8.3278 17.9561C8.45969 16.9055 8.02793 15.8631 7.19175 15.2135L6.6463 14.7897C6.13101 14.3893 6.13101 13.6107 6.6463 13.2103L7.19174 12.7865C8.02793 12.1369 8.45968 11.0945 8.3278 10.0439L8.24177 9.35853C8.16049 8.71107 8.71107 8.16049 9.35853 8.24177L10.0439 8.3278C11.0945 8.45968 12.1369 8.02793 12.7865 7.19175L13.2103 6.6463Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.d84294b23ebff2719009745de93f21b3.svg";
export { ForwardRef as ReactComponent };